<div id="app-wrapper" [style]="{'--session-color': sessionColor}"  >
  <ngx-loading-bar [color]="sessionColor"></ngx-loading-bar>
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  <app-cta-prompt></app-cta-prompt>
</div>

